export const dashboardEntry = {
  key: 'surface-analytics',
  title: 'Attack surface analytics',
  description: 'What you expose to the internet, where it lives, and which parts need attention first.',
  route: '/surface/analytics',
  // Lucide icon name in kebab-case; the hub maps it to a component.
  icon: 'globe',
  apps: ['surface'],
  // The API serves owners and admins only, like the inventory it summarizes.
  adminOnly: true,
  // The route sits behind this flag (FeatureFlagRoute in App.tsx).
  flag: 'surface.uamReads',
} as const;
